import { render } from "./RecipeIntroduceMain.vue?vue&type=template&id=20368cc4&scoped=true"
import script from "./RecipeIntroduceMain.vue?vue&type=script&lang=js"
export * from "./RecipeIntroduceMain.vue?vue&type=script&lang=js"

import "./RecipeIntroduceMain.vue?vue&type=style&index=0&id=20368cc4&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/todaymeal_front/todaymeal_front/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20368cc4"]])

export default __exports__